import type { SelectChoice } from '@snap-types/models/auto-configurator/state';
import { Nullish } from '@snap-types/types/nullish';

export function buildNonNullableSelectChoice(value: string): SelectChoice {
  return {
    label: value,
    value,
  };
}

export function buildSelectChoice(value: Nullish<string>): SelectChoice | null {
  if (!value) {
    return null;
  }

  return buildNonNullableSelectChoice(value);
}
